import React, { Component } from 'react'
import Select from 'react-select'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import AtributoDinamicoInstancia from '../atributoDinamico/AtributoDinamicoInstancia.js'
import { atributosDinamicosRequeridosFaltantes, castValoresDinamicos } from '../atributoDinamico/helpers.js'
import * as Constants from '../atributoDinamico/constants.js'
import Loading from '../ui/Loading.js'
import { FormattedMessage } from 'react-intl'

/**
 * VEC-3451 — "Formulario Asociado".
 *
 * Se renderiza como una card nueva y separada (no inline debajo de la pregunta que
 * lo dispara) cuando esa pregunta se responde afirmativamente. Trae las preguntas
 * del tipo_formulario asociado (GET /api/tipoformulario/{id}) y las responde con el
 * mismo patrón/componentes que usa el formulario padre (AtributoDinamicoInstancia).
 *
 * Reporta cada cambio al padre vía onChange({ tipo_formulario_id, movil_id,
 * valores_dinamicos, completo }) — el padre lo guarda tal cual en
 * valores_dinamicos[index].formulario_asociado, que es exactamente el shape que
 * espera el backend (FormularioController::procesarFormularioAnidado()).
 */
class FormularioAsociadoBloque extends Component {
  constructor(props) {
    super(props);
    this.ajaxHandler = new AjaxHandler();
    this.handleChangeAtributoDinamico = this.handleChangeAtributoDinamico.bind(this);
    this.handleMovilChange = this.handleMovilChange.bind(this);
    this.getBackendMoviles = this.getBackendMoviles.bind(this);
    this.notificarCambio = this.notificarCambio.bind(this);
    this.state = {
      loading: true,
      tipoFormulario: null,
      valores_dinamicos: [],
      movil: null,
    };
  }

  componentDidMount() {
    this.ajaxHandler.subscribe(this);
    const asociadoExistente = this.props.asociadoExistente;
    // Si el formulario ya existe (EDIT/VIEW) y ya tiene un formulario asociado
    // guardado para esta pregunta, el propio asociado ya trae su tipo_formulario
    // con los atributos — evita un GET extra y, sobre todo, permite cargar las
    // respuestas ya guardadas.
    const tipoFormularioPromise = asociadoExistente
      ? Promise.resolve(asociadoExistente.tipo_formulario)
      : this.ajaxHandler.getJson('/tipoformulario/' + this.props.tipoFormularioAsociadoId);
    tipoFormularioPromise
      .then((tipoFormulario) => {
        const valores_dinamicos = castValoresDinamicos(
          tipoFormulario.atributos_dinamicos,
          asociadoExistente ? asociadoExistente.valores_dinamicos : []
        );
        this.setState({
          tipoFormulario,
          valores_dinamicos,
          movil: asociadoExistente ? asociadoExistente.movil : null,
          loading: false
        }, this.notificarCambio);
      })
      .catch((er) => {
        console.log(er);
        this.setState({ loading: false, tipoFormulario: null });
      });
  }

  componentWillUnmount() {
    this.ajaxHandler.unsubscribe();
  }

  incompleto() {
    if (this.state.tipoFormulario && this.state.tipoFormulario.con_movil && !this.state.movil) {
      return true;
    }
    return atributosDinamicosRequeridosFaltantes(this.state.valores_dinamicos) > 0;
  }

  notificarCambio() {
    this.props.onChange({
      tipo_formulario_id: this.state.tipoFormulario ? this.state.tipoFormulario.id : null,
      movil_id: this.state.movil ? this.state.movil.id : null,
      valores_dinamicos: this.state.valores_dinamicos,
      activo: 1,
      completo: !this.incompleto(),
    });
  }

  handleChangeAtributoDinamico(index, key, value) {
    this.state.valores_dinamicos[index][key] = value;
    this.setState({
      valores_dinamicos: this.state.valores_dinamicos
    }, this.notificarCambio);
  }

  handleMovilChange(movil) {
    this.setState({ movil }, this.notificarCambio);
  }

  getBackendMoviles(searchTerm) {
    const tipoFormulario = this.state.tipoFormulario;
    const tipoFormularioId = tipoFormulario ? tipoFormulario.id : null;
    const searchTipoFormulario = (tipoFormulario && tipoFormulario.movil_estados_disponibles_json) ? ('&tipoFormulario=' + tipoFormularioId) : '';
    const buscarPor = (tipoFormulario && tipoFormulario.buscar_movil_por === 'unidad') ? '&buscarPor=unidad' : '';
    return this.ajaxHandler.getJson('/moviles/simple-search?search=' + searchTerm + searchTipoFormulario + buscarPor).then((res) => {
      return {
        options: res,
        complete: true
      };
    });
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="card pull-up">
          <div className="card-content">
            <div className="card-body">
              <Loading />
            </div>
          </div>
        </div>
      );
    }

    const tipoFormulario = this.state.tipoFormulario;
    if (!tipoFormulario) return null;

    return (
      <div className="card pull-up">
        <div className="card-content">
          <div className="card-body">
            <h4 className="form-section">
              <i className="fa fa-sitemap"></i> {tipoFormulario.nombre}
            </h4>
            {tipoFormulario.con_movil && (
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-md-3 label-control col-form-label" htmlFor="movilAsociado">
                      <FormattedMessage id="formularioAsociadoBloque.label_movil" defaultMessage="Móvil *:" />
                    </label>
                    <div className="col-md-9">
                      <Select.Async
                        key={tipoFormulario.id}
                        name="movilAsociado"
                        value={this.state.movil}
                        valueKey="id"
                        labelKey={tipoFormulario.buscar_movil_por === 'unidad' ? 'unidad' : 'dominio'}
                        autoload={!this.props.disabled}
                        loadOptions={this.getBackendMoviles}
                        onChange={this.handleMovilChange}
                        disabled={this.props.disabled}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.state.valores_dinamicos.map((atributoDinamico, index) => {
              if (!atributoDinamico || !atributoDinamico.activo) return null;
              return (
                <div className="row" key={index}>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <AtributoDinamicoInstancia
                        movil={this.state.movil}
                        ocultarInput={this.props.disabled}
                        disabled={this.props.disabled}
                        handleChange={(name, value) => this.handleChangeAtributoDinamico(index, name, value)}
                        atributo={atributoDinamico}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default FormularioAsociadoBloque;
